<template>
  <v-container fluid pa-0 class="fill-height">
    <v-row class="fill-height">
      <v-col :sm="12" :md="12" :lg="12" class="navy lighten-3 pa-10 pa-lg-0">
        <v-row justify="center" class="pt-10 fill-height">
          <v-col :lg="5">
            <v-row class="fill-height" align="center">
              <v-col>
                <slot name="main"></slot>
              </v-col>
            </v-row>
          </v-col>

          <v-col :cols="12">
            <v-row align="end" class="fill-height">
              <v-col>
                <FooterList />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FooterList from "./FooterList.vue"

export default {
  components: {
    FooterList,
  },
}
</script>
